import { useMemo } from "react";
import type { NewsState } from "@/components/widgets/News/types";

export const useNewsState = (ticker: string): NewsState => {
	return useMemo(
		() => ({
			ticker,
			columnOrder: ["publication_date", "title"],
			pagination: {
				limit: 10,
				offset: 0,
			},
		}),
		[ticker],
	);
};
